module.exports = __webpack_public_path__ + "img/sup_awake.fe927a61.png";